import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "creationV2__body" }
const _hoisted_2 = { class: "creationV2__scroll-wrapper" }
const _hoisted_3 = { class: "creationV2__container" }
const _hoisted_4 = { class: "flex flex-col gap-2 lg:gap-[calc(8px+0.2vw)]" }
const _hoisted_5 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_6 = { class: "flex flex-col gap-2 lg:gap-[calc(8px+0.3vw)]" }
const _hoisted_7 = { class: "flex gap-0.5 lg:gap-[calc(2px+0.1vw)] w-full" }
const _hoisted_8 = ["for"]
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = { class: "flex creation__text-small text-creation-on-background/creation-medium" }
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = { class: "flex-1 text-right" }
const _hoisted_13 = { class: "inline-flex self-end justify-end sticky bottom-0" }
const _hoisted_14 = {
  key: 0,
  class: "button button--circle-creation opacity-0 pointer-events-none"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", { class: "button__icon stroke-2" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#arrow-right" })
], -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          appear: "",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.agentMessage), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          appear: "",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], (i) => {
                  return _createElementVNode("label", {
                    key: i,
                    for: `rating${i}`,
                    class: "flex-1 cursor-pointer select-none"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: `rating${i}`,
                      name: "rating",
                      value: i,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rating) = $event)),
                      class: "sr-only peer"
                    }, null, 8, _hoisted_9), [
                      [_vModelRadio, _ctx.rating]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center justify-center flex-shrink-0 py-1.5 sm:px-[calc(6px+0.2vw)] sm:py-[calc(6px+0.2vw)] rounded-[calc(6px+0.2vw)] lg:text-[calc(16px+0.4vw)] font-bold text-creation-on-background peer-checked:bg-creation-on-background peer-checked:text-creation-background transition", {
                                            'bg-creation-on-background/20 border border-creation-on-background/creation-medium hover:border-creation-on-background/creation-full': _ctx.showBackgroundImage,
                                            'bg-creation-on-background/creation-separator hover:bg-creation-on-background/creation-low': !_ctx.showBackgroundImage }])
                    }, _toDisplayString(i), 3)
                  ], 8, _hoisted_8)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('creation.NPSNotLikelyLabel')), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('creation.NPSVeryLikelyLabel')), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          (!_ctx.showContinueButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            name: "custom-classes",
            "enter-active-class": "animate__fadeInUp",
            "leave-active-class": "animate__fadeOutDown"
          }, {
            default: _withCtx(() => [
              (_ctx.showContinueButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "button button--circle-creation button--circle-creation-primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next())),
                    tabindex: "5"
                  }, _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}